import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import * as React from "react";
import { connect } from "react-redux";
import { Container, Dropdown, Accordion, Card, Button, Form, Spinner, } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { resolve, reject } from "q";
import { ToastContainer, toast } from "react-toastify";
import Customerorderslideout from '../Customerorderslideout';
import { VendorService } from "../../Common/Services/VendorService";
import { Utils } from "../../Common/Utilis";
import _ from "lodash";
import paginationFactory from 'react-bootstrap-table2-paginator';
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import createDOMPurify from "dompurify";
import chevronRight from "../../Common/Assets/Images/icons/bx-chevron-right.svg";
import moment from "moment";
import { JobOrderService } from "../../Common/Services/JobOrderService";
import  VendorQuotationsSlideout from './VendorQuotationsSlideout';
import  JobCreations  from '../JobCreations';
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import Vendororderslideout from '../Vendororderslideout';


import { SingleDropdownListWithoutSearch } from "../../Common/Components/SingleDropdownListWithoutSearch";

const { SearchBar } = Search;

import 'react-tabs/style/react-tabs.css';


const DOMPurify = createDOMPurify(window);

class VendorQuotations extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      defaultActiveKey : this.props.taboption ? this.props.taboption : "first",
      footershow : this.props.CustomerPoNumber ? true : false,
      isOrderDate: true,
      isvendorname: true,
      isvendorOrderType: true,
      isvendorPoNumber: true,
      partNos:true,
      partNames:true,
      htmlItem: [],
      htmlErrorItem: [],
      htmlWarningItem: [],
      searcResult: [],
      searcResultReceiving: [],
      searcResultCompleted: [],
      orderid: 0,
      jobid: 0,
      customername: '',
      customerpo: '',
      receivedStatus: '',
      orderdate: null,
      jobno: '',
      partno: '',
      partname: '',
      duedate: null,
      qty: 0,
      vendororderid: 0,
      vendorordertype: 'Material',
      selectedcolumn: "All",
      selectOptions: [{
        id: 'All', name: 'All'
      },
      { id: 'Vendor PO Number', name: 'Vendor PO Number' },
      { id: 'Vendor Name', name: 'Vendor Name' },
      { id: 'Part No', name: 'Part No' },
      { id: 'Part Name', name: 'Part Name' },
      { id: 'Quotation Type', name: 'Quotation Type' },
      { id: 'Order Date', name: 'Order Date' },
      ],
      receivingStatusOptions: [
        { id: 'Select', name: 'Select' },
        { id: 'Completed', name: 'Completed' },
      { id: 'Partial', name: 'Partial' }
      ],
      expandedRows: [],
      formData: {
        TenantId: 0,
        ReceivingData: [],
      },
    };


  }


  componentDidMount() {

    this.getJobItems();
  }
 
  componentDidUpdate(prevProps) {
    if (prevProps.locationId != this.props.locationId && !this.state.showSlideout) {
      this.getJobItems();
    }
  }


  getJobItems() {

    let requestlist = { ...this.state.requestlist };
    requestlist.showCompleted = false;
    JobOrderService.GetVendorQuotationList(requestlist)
      .then(async (result: any[] | null) => {
        if (result != null) {
          // console.log(result);
          this.setState({ searcResult: result }, () => {

          });
        }
        resolve();
      })
      .catch((err: any) => {
        toast.error(`Server Error, ${err}`);
        reject();
      });
  }

  shownewslideout = () => {
    this.setState({ isStateChanged: false,footershow:false ,showSlideout: true, orderid: 0, jobid: 0, customername: '', customerpo: '', orderdate: null, jobno: '', partno: '', partname: '', duedate: null, qty: 0, vendororderid: 0, vendorordertype: 'Material', isSpinner: false, });
  };


  showslideout = () => {
    this.setState({ showSlideout: true, isSpinner: false, });
  };

  closeSlideOut = () => {
    this.setState({ showSlideout: false,showCustomerSlideout:false, isSpinner: false, });
    this.getJobItems();
  };

    closeSlideOut1 = () => {
    this.setState({ showVSlideout: false,vendororderid:0, isSpinner: false, });
    this.getJobItems();
  };

  rowEvents = {

    onClick: (e: any, row: any, rowIndex: any) => {
      console.log("pppppp----------",e.target.className);
      // if (row.receivedStatus === 'Completed' || row.receivedStatus === 'Initial') {
      if(e.target.className=="badge badge-pill cursor-pointer badge-primary color-green")
        {
          if(!row.status.includes(',')){
          this.setState({
            showVSlideout: true, vendororderid: parseInt(row.vendororderid),vendorordertype:row.vendorOrderType,isSpinner: false
          });

          }
        }else if(e.target.className=="badge badge-pill badge-primary color-orange"){return;
        }else{
        this.setState({
          showSlideout: true,status:row.status, orderid: 0, jobid: row.jobId, customername: row.vendorName,
          customerpo: row.vendorPoNumber, orderdate: row.orderDate, jobno: row.jobNo, partno: row.partNo, partname: row.partName, qty: row.qty, duedate: row.dueDate, vendororderid: row.orderID, vendorordertype: row.vendorOrderType, receivedStatus: row.receivedStatus, isSpinner: false,
        });
      }
     // }
    },
  };

  handleSelectedItem1 = (control: any, id: any) => {
    let searcResult1 = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.searcResult))
    );

    let isOrderDate = id == "Order Date" ? true : false;
    let isvendorname = id == "Vendor Name" ? true : false;
    let isvendorOrderType = id == "Quotation Type" ? true : false;
    let isvendorPoNumber = id == "Vendor PO Number" ? true : false;
    let chkispartno = id == "Part No" ? true :false;
    let chkispartname = id == "Part Name" ? true :false;


    if (id == "All") {
      isOrderDate = true;
      isvendorname = true;
      isvendorOrderType = true;
      isvendorPoNumber = true;
      chkispartno=true;
      chkispartname=true;
    }


    this.setState({
      searcResult: [], selectedcolumn: id, isOrderDate: isOrderDate, isvendorname: isvendorname,
      isvendorOrderType: isvendorOrderType, isvendorPoNumber: isvendorPoNumber,partNos:chkispartno,partNames:chkispartname,
    },
      () => {
        this.setState({ searcResult: searcResult1 });
      }

    );

  };

  showSlideOut = (row, type) => {
    
    if (type === 'customer') {
    
      this.setState({ isStateChanged: false,footershow:false , showCustomerSlideout: true, showJobSlideout: false, orderid: row.customerOrderID });
    }
    else if (type === 'job') {
      this.setState({isStateChanged: false,footershow:false ,showJobSlideout: true, showCustomerSlideout: false, orderdetailid: row.orderDetailId , jobid: row.jobId, qtyOrdered: row.qty, partname: row.partName, partNo: row.partNo, selectedCustomer: row.customerName, productid: row.partId, CustomerPoNumber: row.customerPoNumber, itemNo: row.itemId });
    }
    else if (type === 'vendor') {
      this.setState({
        showSlideout: true, orderid: 0, jobid: row.jobId, customername: row.vendorName,
        customerpo: row.vendorPoNumber, orderdate: row.orderDate, jobno: row.jobNo, partno: row.partNo, partname: row.partName, qty: row.qty, duedate: row.dueDate, vendororderid: row.orderID, vendorordertype: row.vendorOrderType, receivedStatus: row.receivedStatus, isSpinner: false,
      });
    }
  };

 

  backToJob() {
    this.props.backToJob();
  }

  handleDiscard() {
    this.setState({ isStateChanged: false,footershow:false }, () => {
      this.closeSlideOut();
    });
  }

  closeJobSlideout = () => {
    this.setState({ showJobSlideout: false, isSpinner: false, });

  };




  render() {
    const { permissions } = this.props; 
    const hasAddQuotationPermission = permissions && permissions['Vendor Quotations'] ? permissions['Vendor Quotations'].includes('Add Quotation') : false;


    const customTotal = (from, to, size) => (
      <span className="text-muted">
        Showing {from} to {to} of {size} entries
      </span>
    );
    const options = {

      showTotal: true,
      hideSizePerPage: false,
      hidePageListOnlyOnePage: true,
      paginationTotalRenderer: customTotal,
      disablePageTitle: true,
      sizePerPageList: [{
        text: '10', value: 10
      },
      {
        text: '25', value: 25
      },
      {
        text: '50', value: 50
      },

      {
        text: 'All', value: this.state.searcResult.length
      }] // A numeric array is also available. the purpose of above example is custom the text
    };


    const columns = [
      // {
      //   dataField: 'orderID',
      //   text: '#',
      //   headerStyle: { width: '10px' },
      // },
        {
        dataField: 'partno',
        text: 'partno',
        searchable: this.state.partNos,
        className: "text-truncate",
        hidden:true,
      },{
        dataField: 'partname',
        text: 'partname',
        searchable: this.state.partNames,
        className: "text-truncate",
        hidden:true,
      },
      {
        dataField: 'vendorPoNumber',
        text: 'Quotation No.',
        sort: true,
        headerStyle: { width: '100px' },
        searchable: this.state.isvendorPoNumber,
      },
      {
        dataField: 'vendorOrderType',
        text: 'Quotation Type',
        sort: true,
        headerStyle: { width: '100px' },
        searchable: this.state.isvendorOrderType,
      },
      // {
      //   dataField: 'vendorName',
      //   text: 'Vendor',
      //   sort: true,
      //   headerStyle: { width: '150px' },
      //   searchable: this.state.isvendorname,
      // },
      {
        dataField: 'vendorName',
        text: 'Vendor',
        sort: true,
        headerStyle: { width: '150px' },
        searchable: this.state.isvendorname,
        formatter: (cell) => {
          const className = cell === 'Multiple Vendors' ? 'divgreen' : '';
          return <span className={className}>{cell}</span>;
        },
      },
      {
        dataField: 'orderDate',
        text: 'Date',
        sort: true,
        headerStyle: { width: '100px' },
        searchable: this.state.isOrderDate,
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <EllipsisWithTooltip placement="bottom">
              {moment(row.orderDate).format("MM/DD/YYYY")}
            </EllipsisWithTooltip>
          );
        },
         filterValue: (cell: any, row: any) => {
                  return moment(row.orderDate).format("MM/DD/YYYY");
                },
      },
      // {
      //   dataField: 'qty',
      //   text: 'Order Qty',
      //   sort: true,
      //   headerStyle: { width: '150px' },
      //   headerClasses: 'amount',
      //   classes: 'text-end pe-4 divgreen',
      //   formatter: (cell: any, row: any, rowIndex: any) => {
      //     return (
      //       <EllipsisWithTooltip placement="bottom">
      //         {row.qty}
      //       </EllipsisWithTooltip>
      //     );
      //   },
      // },
      {
        dataField: 'totalAmount',
        text: 'Total Amount',
        sort: true,
        headerStyle: { width: '150px' },
        headerClasses: 'amount',
        classes: 'text-end pe-4 divgreen',
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <EllipsisWithTooltip placement="bottom">
              {Utils.currencyFormat(row.totalAmount)}
            </EllipsisWithTooltip>
          );
        },
      filterValue: (cell, row) => {
          return row.totalAmount.toFixed(2);
        },
      },
      // {
      //         dataField: 'status',
      //         text: 'Status',
      //         sort: true,
      //         headerStyle: { minWidth: "100px" , paddingLeft:"6%"},
      //         searchable: this.state.isstatus,
      //         formatter: (cell: any, row: any, rowIndex: any) => {
      //           return ( 
      //             <>
      
      //             <EllipsisWithTooltip placement="bottom" style={{paddingLeft:"6"}} >
                      
      //                <span className={row.status==null ? "badge badge-pill badge-primary color-orange" :  "badge badge-pill cursor-pointer badge-primary color-green"}> {row.status==null? "Open" : row.status} </span>
      //               </EllipsisWithTooltip>
      //               </>
      //           );
      //       },
      //       filterValue: (cell: any, row: any) => {
      //     return row.status == null ? "Open" : row.status;
      //   },
      //       },
      
  {
  dataField: 'status',
  text: 'Status',
  sort: true,
  headerStyle: { minWidth: "100px", paddingLeft: "6%" },
  searchable: this.state.isstatus,
  formatter: (cell: any, row: any) => {

  const statuses = row.status
    ? row.status.split(",").map(s => s.trim())
    : ["Open"];

  const badgeClass =
    row.status == null
      ? "badge badge-pill badge-primary color-orange"       
      : "badge badge-pill cursor-pointer badge-primary color-green";     

  const renderedStatuses = statuses.map((s, i) => {
    const isCancelled = s.endsWith("(C)");
    const cleanText = isCancelled ? s.replace("(C)", "").trim() : s;

    return (
      <span
        key={i}
        style={{
          textDecoration: isCancelled ? "line-through" : "none"
        }}
      >
        {cleanText}{i < statuses.length - 1 ? ", " : ""} 
      </span>
    );
  });

  const limited = renderedStatuses.length > 3
    ? [...renderedStatuses.slice(0, 3), <span key="more">...</span>]
    : renderedStatuses;

  return (
    <span
      className={badgeClass}
      title={statuses.join(", ")}
      style={{
        padding: "5px 10px"
      }}
       onClick={(e) => {
    e.stopPropagation();
    if (!row.status.includes(",")) {
      this.setState({
        showVSlideout: true,
        vendororderid: parseInt(row.vendororderid),
        vendorordertype: row.vendorOrderType,
        isSpinner: false
      });
    }
  }}
    >
      {limited}
    </span>
  );
},

  // formatter: (cell: any, row: any, rowIndex: any) => {
  //   const statuses = row.status
  //     ? row.status.split(",").map(s => s.trim())
  //     : ["Open"];
    
  //   const badgeText = statuses.length > 3
  //     ? statuses.slice(0, 3).join(", ") + " ..."
  //     : statuses.join(", ");

  //   return (
  //     <span
  //       className={
  //         row.status == null
  //           ? "badge badge-pill badge-primary color-orange"
  //           : "badge badge-pill cursor-pointer badge-primary color-green"
  //       }
  //       title={statuses.join(", ")}
  //       style={{  padding: "5px 10px" }}
  //     >
  //       {badgeText}
  //     </span>
  //   );
  // },
  filterValue: (cell: any, row: any) => row.status == null ? "Open" : row.status,
}


    ];




    const {

      showSlideout,
      showVSlideout,
      showJobSlideout,
      showCustomerSlideout
    } = this.state;




    return (

      <>
      
        <React.Fragment>



          <Container fluid className="body-sec" >
        
            <div className="page-heading  d-flex  ">

              Vendor Quotations
              {hasAddQuotationPermission &&
              <div className="action-group d-flex flex-row ml-auto">
                { <Button onClick={this.shownewslideout}>Add Quotation</Button> }
              </div>
             }
            </div>

           

          

                  <ToolkitProvider
                    keyField="id"
                    data={this.state.searcResult}
                    columns={columns}

                    search
                  >
                    {
                      props => (
                        <div>

<section className="d-flex flex-wrap gap-3 pb-2">
                            <div className="position-relative">
                              <SearchBar {...props.searchProps} />
                               {props.searchProps.searchText && props.searchProps.searchText.trim() !== "" && (
                              <button
                                type="button"
                                className="btn-clear-search"
                                onClick={() => props.searchProps.onSearch("")}
                                title="Clear search"
                              >
                                ×
                              </button>
                            )}
                            </div>

                            <div 
                            //className="input-group w-auto"
                            className="col-12 col-md-2"
                            >
                                <SingleDropdownListWithoutSearch
                                  
                                  itemList={this.state.selectOptions}
                                  handleSelectedItem={this.handleSelectedItem1.bind(this, 1)}
                                  defaultItem={this.state.selectedcolumn}
                                  defaultText={"Select Filter"}
                                  defaultName={this.state.selectedcolumn}
                                  controlID="1"
                                  id={"ddlselected"}

                                />
                            </div>

                          </section>
                          <section className="pb-3">
                            <div className="table-responsive1 divbottom"  >
                              <div className="ml-auto transactions-list payroll-tbl">
                          <BootstrapTable
                            {...props.baseProps}
                            rowEvents={this.rowEvents}
                            pagination={paginationFactory(options)}
                          />
                       </div>
                            </div>
                          </section>
                        </div>
                      )
                    }
                  </ToolkitProvider>



            {(showSlideout &&

<VendorQuotationsSlideout
closeSlideOut={this.closeSlideOut}
orderid={this.state.orderid}
receivedStatus={this.state.receivedStatus}
CustomerPoNumber={this.state.customerpo}
poNumber={this.state.poNumber}
productid={this.state.productid}
partname={this.state.partname}
partNo={this.state.partNo}
qtyOrdered={this.state.qtyOrdered}
jobid={this.state.jobid}
itemNo={this.state.itemNo}
vendororderid={this.state.vendororderid}
vendorordertype={this.state.vendorordertype}
selectedCustomer={this.state.selectedCustomer}
orderdate={this.state.orderdate}
dueDate={this.state.dueDate}
jobDesc={this.state.jobDesc}
status={this.state.status}
id={this.state.id}
>


</VendorQuotationsSlideout>


              )}

          {(showVSlideout &&
              <Vendororderslideout
                closeSlideOut={this.closeSlideOut1}
                orderid={this.state.vendororderid}
                vendororderid={this.state.vendororderid}
                vendorordertype={this.state.vendorordertype}
              ></Vendororderslideout>)}

          </Container>

          {(this.state.isSpinner || this.state.isSaveSpinner) && (
            <div className="loader-spinner d-flex justify-content-center align-items-center">
              <Spinner animation="border" variant="success" />
            </div>
          )}

        </React.Fragment>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  permissions: state.PagePermissionReducer.permissions,
  locationId: state.LocationReducer.locationId
});

export default connect(mapStateToProps)(VendorQuotations);